/* eslint-disable default-param-last, no-unused-vars, spaced-comment */
import inView from 'in-view';
import { filterableContentTemplate, noResultsTemplate } from './template';
import { emPagination, emLoadMore } from '../pagination';
import { getParams, setParams } from './params.js';
import { setActiveFilters, clearFilters } from './active-filters.js';
import	initFavoriteDocuments from './favorite-documents';
import	initPopularDocuments from './popular-documents';

// Set domain to current domain and endpoint to post factory.
const { origin } = window.location;
const apiUrl = `${origin}/wp-json/em/v1/post_factory`;

/**
 * Pass parameters and fetch from post factory api.
 * @param  {Object}   element  the element to append/replace the html.
 * @param  {Object}   params   the query parameters to pass to the rest api.
 * @param  {Function} template the html markup.
 */
const getFilterableContent = (element, params = {}, template) => {
	(async () => {
		// Loop through the parameters and format for the query string.
		const esc = encodeURIComponent;
		let query = Object.keys(params).map((k) => {
			if (k === 'post_types') {
				const types = params[k];
				return `${esc(k)}=${esc(types.split(','))}`;
			}

			return `${esc(k)}=${esc(params[k])}`;
		});
		query = query ? `?${query.join('&')}` : '';

		// Fetch the data.
		element.replaceChildren(); // Makes `element` empty, thus showing loading spinner
		const response = await fetch(apiUrl + query);
		let data = await response.json();
		data = data ? JSON.parse(data) : false;

		if (data.posts) {
			const block = document.getElementById(data.block_id);
			const resultCount = block.querySelector('.em-filterable-content__count span');

			// Set the result count.
			if (resultCount) {
				resultCount.innerHTML = data.found_posts.toLocaleString(document.getElementsByTagName('html')[0].getAttribute('lang'));
			}

			// Get the posts from the data.
			const { posts, not_found_message } = data; // eslint-disable-line
			let html = '';

			// Pass the post data to the template.
			posts.forEach((post) => {
				html += template(post);
			});

			// Output the pagination.
			if (data.pagination === 'load_more') {
				html += emLoadMore(data.max_num_pages, data.current_page);
			} else {
				html += emPagination(data.max_num_pages, data.current_page, 8, 'em-col pagination');
			}

			// Append or replace the markup.
			if (data.pagination === 'load_more' && data.current_page > 1) {
				element.innerHTML += html;
			} else {
				element.innerHTML = html;
			}

			// No Posts Found
			if (posts.length === 0) {
				element.innerHTML = noResultsTemplate(not_found_message);
			}

			// Process the pagination actions.
			const pageNumbers = block.querySelectorAll('.page-numbers');
			const contentContainer = block.querySelector('.em-filterable-content__listings');
			const inputs = block.querySelectorAll('.em-filterable-content__filters [type="checkbox"], .filter-search');
			const filterContainer = block.querySelector('.em-filterable-content__filter-container');

			// Loop through page numbers.
			pageNumbers.forEach((page) => {
				page.onclick = (e) => {
					page = e.target;
					const { parentNode } = page;
					if (parentNode) {
						page.parentNode.removeChild(page);
					}

					filterContainer.setAttribute('data-page', page.dataset.page);
					setParams(inputs, block.id, page.dataset.page);

					// Fetch the content.
					getFilterableContent(contentContainer, getParams(block.id, true, page.dataset.page), filterableContentTemplate);
				};
			});

			// Set active filter "pills".
			setActiveFilters(block, inputs, getFilterableContent);

			// Initiate clear filters button..
			clearFilters(block, inputs, getFilterableContent);

			// disable terms that don't have posts.
			const { terms } = data;

			inputs.forEach((input) => {
				const listItem = input.parentElement.parentElement;
				const termId = input.getAttribute('data-term-id');
				if (terms) {
					if (termId in terms) {
						input.removeAttribute('disabled');
						//listItem.style.display = 'list-item';
						const count = input.nextSibling.querySelector('.count');
						count.innerHTML = `(${terms[termId]})`;
						if (terms[termId] === 0) {
							input.setAttribute('disabled', 'disabled');
							// listItem.style.display = 'none';
						}
					} else if (input.hasAttribute('data-term-id')) {
						input.setAttribute('disabled', 'disabled');
						// listItem.style.display = 'none';
					}
				} else {
					//listItem.style.display = 'list-item';
					input.removeAttribute('disabled');
				}
			});

			if (data.pagination === 'load_more') {
				const links = block.querySelectorAll('a:not(.btn)');
				links.forEach((link) => {
					link.setAttribute('target', '_blank');
					link.setAttribute('rel', 'noopener norefferer');
				});

				// Automatically load more results when the "Load More" button is in view.
				inView.offset(100);
				inView('.em-filterable-content__listings > .btn')
					.once('enter', (loadMoreEl) => {
						loadMoreEl.click();
					});
			}

			// Init favorite document toggles.
			initFavoriteDocuments();
			initPopularDocuments();
		}
	})();
};

export default getFilterableContent;
